export default "__VITE_ASSET__9122e507__"